<template>
  <v-card
    class="card text-xs-center"
    hover
    :to="link"
    append
  >
    <v-img
      class="white--textimage darken-pseudo darken-with-text"
      :src="img"
      :height="imgHeight"
    >
      <v-container
        fill-height
        fluid
      >
        <v-layout fill-height>
          <v-flex
            xs12
            align-end
            flexbox
          >
            <span
              id="headline"
              class="headline font-weight-black"
              v-text="title"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: ''
    },
    imgHeight: {
      type: String,
      default: '240px'
    },
    link: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.darken-pseudo {
  position: relative;
}

.darken-pseudo:after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.darken-with-text span {
  margin: 0;
  font-size: 2em;
  text-align: center;
  color: white;
  z-index: 1;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

p {
  margin: 0;
  font-size: 2em;
  text-align: center;
  color: white;
  z-index: 3;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
#headline{
  top: 105px;
  min-width: 195px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCard.vue